import image1 from "assets/img/history-of-mikolajow/1_historia.jpg";
import image2 from "assets/img/history-of-mikolajow/2_historia.jpg";
import image3 from "assets/img/history-of-mikolajow/3_historia.jpg";
import image4 from "assets/img/history-of-mikolajow/4_historia.jpg";
import image5 from "assets/img/history-of-mikolajow/5_historia.jpg";
import image6 from "assets/img/history-of-mikolajow/6_historia.jpg";
import image7 from "assets/img/history-of-mikolajow/7_historia.jpg";
import image8 from "assets/img/history-of-mikolajow/8_historia.jpg";
import "assets/scss/archive/mine-now.scss";
import "assets/scss/Components/spyscroll.scss";
import "assets/scss/Views/paralax.scss";
import ParalaxList from "Components/Paralax/ParalaxList";
import { useLayoutEffect } from "react";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Scrollspy from "react-scrollspy";
import { animated, useTransition } from "react-spring";

const HistoryOfMikolajow = ({
  setPageTitle,
  setShowMenuToggler,
  setIsBackgroundMusic,
  setReturnLink,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    setPageTitle(t("The Story of Mikołajów"));
    setShowMenuToggler(true);
    setIsBackgroundMusic(true);
    setReturnLink({ link: "/scene" });
  }, [
    setPageTitle,
    setShowMenuToggler,
    setReturnLink,
    setIsBackgroundMusic,
    t,
  ]);

  const [activePage, setActivePage] = useState(0);

  const transitions = useTransition(activePage, {
    opacity: 1,
    value: 100,
    key: activePage,
    from: { opacity: 0, value: 0 },
    enter: { opacity: 1, value: 100 },
    config: { duration: 1000 },
    exitBeforeEnter: true,
  });
  const updateHandler = (e) => {
    if (!e) {
      return;
    }
    setActivePage(parseInt(e.getAttribute("id").replace("section-", "")));
  };

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Fragment>
      <div className="scrollspy-wrapper">
        <Scrollspy
          onUpdate={updateHandler}
          className="scrollspy"
          items={[
            "section-1",
            "section-2",
            "section-3",
            "section-4",
            "section-5",
          ]}
          currentClassName="active"
        >
          <li>
            <a href="#section-1">&nbsp;</a>
          </li>
          <li>
            <a href="#section-2">&nbsp;</a>
          </li>
          <li>
            <a href="#section-3">&nbsp;</a>
          </li>
          <li>
            <a href="#section-4">&nbsp;</a>
          </li>
          <li>
            <a href="#section-5">&nbsp;</a>
          </li>
        </Scrollspy>
      </div>
      <section id="section-1" className="">
        <ParalaxList />
      </section>
      <section id="section-2" className="vh-25"></section>
      <section id="section-3" className="vh-25"></section>
      <section id="section-4" className="vh-25"></section>
      <section id="section-5" className="vh-25"></section>
      <section className="vh-100"></section>
      <section className="fixedSection">
        {transitions((props, item, key) => {
          return (
            <Fragment>
              {item === 2 && (
                <animated.div style={{ opacity: props.opacity }}>
                  <div className="w-100 vh-100 d-flex flex-column justify-content-end align-items-center position-relative z-index-11">
                    <div className="d-flex flex-column justify-content-center align-items-center col-12 z-index-11 mb-100">
                      <div className="col-6 d-flex justify-content-center align-items-center">
                        <h2 className="text-center">
                          {t("HistoryOfMikolajow1Question")}
                        </h2>
                      </div>
                      <div className="row gx-5 mt-lg-5 mt-2">
                        <div className="d-flex flex-column col-6"></div>
                        <div className="d-flex flex-column col-5">
                          <span
                            className="d-block mt-5 fs-bigBody ps-5"
                            dangerouslySetInnerHTML={{
                              __html: t("HistoryOfMikolajow1Answer"),
                            }}
                          ></span>
                        </div>
                      </div>
                    </div>
                    <div className="position-absolute w-100 h-100 dark-layer">
                      <div className="col-6 position-absolute h-100 overflow-hidden start-0">
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer"
                          style={{
                            backgroundImage: `url(${image1})`,
                            left:
                              item === 2
                                ? props.value.to((y) => {
                                    return `${100 - y}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                      <div className="col-6 position-absolute h-100 overflow-hidden end-0">
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer"
                          style={{
                            backgroundImage: `url(${image2})`,
                            right:
                              item === 2
                                ? props.value.to((y) => {
                                    return `-${50 - y / 2}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </animated.div>
              )}
              {item === 3 && (
                <animated.div style={{ opacity: props.opacity }}>
                  <div className="w-100 vh-100 d-flex flex-column justify-content-end align-items-center position-relative z-index-11">
                    <div className="d-flex flex-column justify-content-center align-items-center col-12 z-index-11 mb-100">
                      <div className="col-6 d-flex justify-content-center align-items-center">
                        <h2 className="text-center">
                          {t("HistoryOfMikolajow2Question")}
                        </h2>
                      </div>
                      <div className="row gx-5 mt-lg-5 mt-2">
                        <div className="d-flex flex-column col-lg-7 col-6"></div>
                        <div className="d-flex flex-column col-lg-4 col-5">
                          <span className="d-block mt-5 fs-bigBody px-3">
                            {t("HistoryOfMikolajow2Answer")}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="position-absolute w-100 h-100 dark-layer">
                      <div className="col-6 position-absolute h-100 overflow-hidden start-0">
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer"
                          style={{
                            backgroundImage: `url(${image3})`,
                            left:
                              item === 3
                                ? props.value.to((y) => {
                                    return `${100 - y}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                      <div className="col-6 position-absolute h-100 overflow-hidden end-0">
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer"
                          style={{
                            backgroundImage: `url(${image4})`,
                            right:
                              item === 3
                                ? props.value.to((y) => {
                                    return `-${50 - y / 2}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </animated.div>
              )}
              {item === 4 && (
                <animated.div style={{ opacity: props.opacity }}>
                  <div className="w-100 vh-100 d-flex flex-column justify-content-end align-items-center position-relative z-index-11">
                    <div className="d-flex flex-column justify-content-center align-items-center col-12 z-index-11 mb-100">
                      <div className="col-6 d-flex justify-content-center align-items-center">
                        <h2 className="text-center">
                          {t("HistoryOfMikolajow3Question")}
                        </h2>
                      </div>
                      <div className="row gx-5 mt-lg-5 mt-2">
                        <div className="d-flex flex-column col-lg-7 col-6"></div>
                        <div className="d-flex flex-column col-lg-4 col-5">
                          <span className="d-block mt-5 fs-bigBody px-3">
                            {t("HistoryOfMikolajow3Answer")}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="position-absolute w-100 h-100 dark-layer">
                      <div className="col-6 position-absolute h-100 overflow-hidden start-0">
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer"
                          style={{
                            backgroundImage: `url(${image5})`,
                            left:
                              item === 4
                                ? props.value.to((y) => {
                                    return `${100 - y}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                      <div className="col-6 position-absolute h-100 overflow-hidden end-0">
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer"
                          style={{
                            backgroundImage: `url(${image6})`,
                            right:
                              item === 4
                                ? props.value.to((y) => {
                                    return `-${50 - y / 2}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </animated.div>
              )}
              {item === 5 && (
                <animated.div style={{ opacity: props.opacity }}>
                  <div className="w-100 vh-100 d-flex flex-column justify-content-end align-items-center position-relative z-index-11">
                    <div className="d-flex flex-column justify-content-center align-items-center col-12 z-index-11 mb-100">
                      <div className="col-6 d-flex justify-content-center align-items-center">
                        <h2 className="text-center">
                          {t("HistoryOfMikolajow4Question")}
                        </h2>
                      </div>
                      <div className="row gx-5 mt-lg-5 mt-2">
                        <div className="d-flex flex-column col-lg-7 col-6"></div>
                        <div className="d-flex flex-column col-lg-4 col-5">
                          <span
                            className="d-block mt-5 fs-bigBody px-3"
                            dangerouslySetInnerHTML={{
                              __html: t("HistoryOfMikolajow4Answer"),
                            }}
                          ></span>
                        </div>
                      </div>
                    </div>
                    <div className="position-absolute w-100 h-100 dark-layer">
                      <div className="col-6 position-absolute h-100 overflow-hidden start-0">
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer"
                          style={{
                            backgroundImage: `url(${image7})`,
                            left:
                              item === 5
                                ? props.value.to((y) => {
                                    return `${100 - y}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                      <div className="col-6 position-absolute h-100 overflow-hidden end-0">
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer"
                          style={{
                            backgroundImage: `url(${image8})`,
                            right:
                              item === 5
                                ? props.value.to((y) => {
                                    return `-${50 - y / 2}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </animated.div>
              )}
            </Fragment>
          );
        })}
      </section>
    </Fragment>
  );
};

export default HistoryOfMikolajow;
